// Underlined tab row. items: [{ key, label, count? }]
export function Tabs({ items, value, onChange, className = '' }) {
  return (
    <div className={`flex gap-1 overflow-x-auto no-scrollbar ${className}`} style={{ borderBottom: '1px solid var(--border)' }} role="tablist">
      {items.map((item) => {
        const active = item.key === value;
        return (
          <button
            key={item.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.key)}
            className="-mb-px px-3.5 py-2.5 text-sm whitespace-nowrap flex items-center gap-1.5 transition-colors"
            style={{
              color: active ? 'var(--accent)' : 'var(--textMuted)',
              fontWeight: active ? 700 : 500,
              borderBottom: `2px solid ${active ? 'var(--accent)' : 'transparent'}`,
            }}
          >
            {item.label}
            {item.count > 0 && (
              <span className="text-[11px] font-bold px-1.5 rounded-full" style={{ background: 'var(--accentSoft)', color: 'var(--accentHot)' }}>
                {item.count > 99 ? '99+' : item.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

// Compact segmented control, e.g. Today / 7 days / 30 days.
export function Segmented({ items, value, onChange }) {
  return (
    <div className="inline-flex rounded-[10px] p-0.5" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
      {items.map((item) => {
        const active = item.key === value;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className="px-3 py-1.5 rounded-[8px] text-xs font-semibold transition-colors"
            style={{ background: active ? 'var(--accent)' : 'transparent', color: active ? 'var(--accentText)' : 'var(--textMuted)' }}
            aria-pressed={active}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
